import type { BuiltinAdapterOptions, PersistenceAdapter, FilterValues } from '../types';
import { buildStorageKey } from './types';

export function createSessionStorageAdapter(options: BuiltinAdapterOptions): PersistenceAdapter {
  const key = buildStorageKey(options);
  return {
    load: () => {
      try {
        const raw = typeof window !== 'undefined' ? window.sessionStorage.getItem(key) : null;
        if (!raw) return null;
        return JSON.parse(raw) as FilterValues;
      } catch (err) {
        console.warn(`[FilterBar persistence] Failed to load from sessionStorage key "${key}":`, err);
        return null;
      }
    },
    save: (values) => {
      try {
        if (typeof window === 'undefined') return;
        const filtered = options.exclude?.length ? omit(values, options.exclude) : values;
        window.sessionStorage.setItem(key, JSON.stringify(filtered));
      } catch (err) {
        console.warn(`[FilterBar persistence] Failed to save to sessionStorage key "${key}":`, err);
      }
    },
    clear: () => {
      try {
        if (typeof window === 'undefined') return;
        window.sessionStorage.removeItem(key);
      } catch (err) {
        console.warn(`[FilterBar persistence] Failed to clear sessionStorage key "${key}":`, err);
      }
    },
    debounceMs: options.debounceMs ?? 0,
    exclude: options.exclude,
  };
}

function omit(values: FilterValues, keys: string[]): FilterValues {
  const out: FilterValues = {};
  for (const k of Object.keys(values)) {
    if (!keys.includes(k)) out[k] = values[k];
  }
  return out;
}
